export default "__VITE_PUBLIC_ASSET__b3b8687f__"